import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const userSelector = (state: State) => state.user.user;
export const optionsSelector = (state: State) => state.user.options;
export const totalSelector = (state: State) => state.user.total;
export const noMoreSelector = (state: State) => state.user.noMore;
export const pageSelector = (state: State) => state.user.page;
export const errorCodeSelector = (state: State) => state.user.errorCode;

const usersIdsSelector = (state: State) => state.user.users.ids;
const usersEntitiesSelector = (state: State) => state.user.users.entities;

export const usersSelector = createSelector(
  [usersIdsSelector, usersEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);